import api from './client/axios';
import type {
  ApiResponse,
  // DashboardMetrics,
  // MetricPeriod,
} from '@packages/database/types';
export type MetricPeriod = '1d' | '7d' | '30d' | '90d';

// ── Trend ─────────────────────────────────────────────────
export interface MetricWithTrend {
  current: number;
  previous: number;
  delta: number;
  deltaPercent: number;
  trend: 'up' | 'down' | 'flat';
}

// ── Time Series ───────────────────────────────────────────
export interface TimeSeriesPoint {
  date: string;
  value: number;
}

export interface TicketSparklines {
  created: TimeSeriesPoint[];
  completed: TimeSeriesPoint[];
  rejected: TimeSeriesPoint[];
}

// ── Ticket Metrics ────────────────────────────────────────
export interface TicketMetrics {
  byStatus: Partial<Record<string, number>>;
  byPriority: Partial<Record<string, number>>;
  totalOpen: MetricWithTrend;
  created: MetricWithTrend;
  completed: MetricWithTrend;
  pendingReview: number;
  rejected: number;
  sparklines: TicketSparklines;
  period: MetricPeriod;
}

// ── Crew Metrics ──────────────────────────────────────────
export interface CrewMetrics {
  available: number;
  unavailable: number;
  total: number;
  utilizationRate: number;
}

// ── Dashboard Response ────────────────────────────────────
export interface DashboardMetrics {
  ticketMetrics: TicketMetrics;
  crewMetrics: CrewMetrics;
}

// ── Query Params ──────────────────────────────────────────
export interface MetricQueryParams {
  period: MetricPeriod;
  projectId?: string;
}

export const metricsApi = {
  dashboard: async (
    period: MetricPeriod = '7d',
    projectId?: string,
  ): Promise<DashboardMetrics> => {
    const params: Record<string, string> = { period };
    if (projectId) params.projectId = projectId;

    const res = await api.get<ApiResponse<DashboardMetrics>>('/metrics', {
      params,
    });
    return res.data.data!;
  },
} as const;
